import { Link } from '@/i18n/routing';
import { ButtonIcon } from '@mage-ui/components';
import {
  buttonIcon,
  buttonIconIcon,
  courseCard,
  focus,
} from '@mage-ui/styled-system/recipes';
import { LinkBtn } from '../../link-btn/LinkBtn';

export const CourseCardFooter = ({ data, ...props }) => {
  const hasFooter =
    data?.fields?.link_cta ||
    data?.link_cta ||
    data?.fields?.info_cta ||
    data?.info_cta ||
    data?.fields?.link_slug ||
    data?.link_slug ||
    data?.fields?.info_slug ||
    data?.info_slug;

  return (
    hasFooter && (
      <div className={courseCard().bottomContent} {...props}>
        {data?.fields?.info_slug &&
          (data?.fields?.info_cta || data?.info_cta) && (
            <Link
              href={data?.fields?.info_slug || data?.info_slug}
              className={focus()}
            >
              <ButtonIcon
                label={data?.fields?.info_cta || data?.info_cta}
                icon='info'
                classNames={{
                  root: buttonIcon({
                    color: 'primary',
                    variant: 'outlined',
                  }),
                  icon: buttonIconIcon(),
                }}
              />
            </Link>
          )}
        {(data?.fields?.link_cta || data?.link_cta) && (
          <LinkBtn
            text={data?.fields?.link_cta || data?.link_cta}
            icon='edit_note'
            href={data?.fields?.link_slug || data?.link_slug}
          />
        )}
      </div>
    )
  );
};
